import DeepCloudConnect from '@/pages/finances/banking/bankaccount/DeepCloudConnect.vue';
import { payments } from '@/router/finances/payments';

const Ababank = () => import('@/pages/finances/banking/ababank/Ababank.vue');
const AbabankPostfinance = () => import('@/pages/finances/banking/ababank/postfinance/Postfinance.vue');
const Banking = () => import('@/pages/finances/banking/Banking.vue');
const DeepCloudSetup = () => import('@/pages/finances/banking/bankaccount/DeepCloudSetup.vue');
const Ebanking = () => import('@/pages/finances/banking/ebanking/Ebanking.vue');
const Finances = () => import('@/pages/finances/Finances.vue');
const OauthAuthorization = () => import('@/pages/finances/banking/bankaccount/OauthAuthorization.vue');
const OauthCallbackBlink = () => import('@/pages/finances/banking/bankaccount/OauthCallbackBlink.vue');

export default [
  {
    path: '/finances/banking',
    name: 'finances-banking',
    redirect: '/v3/finances/banking',
  },
  {
    path: '/finances/banking/create',
    name: 'finances-bank-create',
    redirect: '/v3/finances/banking/bank-account-new',
    meta: {
      title: 'new_bank_account',
    },
  },
  {
    path: '/finances/banking/:uuid/edit',
    name: 'finances-bank-edit',
    redirect: (to) => `/v3/finances/banking/bank-account/${to.params.uuid}`,
    meta: {
      title: 'edit_bank_account',
    },
  },
  {
    path: '/finances',
    name: 'payments',
    component: Finances,
    redirect: { name: 'payments-list', params: { group: 'open' } },
    children: [
      ...payments,
      {
        path: 'bankfiles/import',
        name: 'finances-bankfiles-import',
        redirect: '/v3/finances/bank-files/upload',
      },
      {
        path: 'bankfiles/:uuid',
        name: 'finances-bankfiles-edit',
        redirect: (to) => `/v3/finances/bank-files/${to.params.uuid}`,
      },
      {
        path: 'export-payments',
        name: 'finances-export-payments',
        redirect: '/v3/finances/payments-export',
      },
      {
        path: 'banking',
        component: Banking,
        children: [
          {
            path: ':id?/deepcloud/setup',
            name: 'finances-bank-deepcloud-setup',
            component: DeepCloudSetup,
            meta: {
              title: 'deepcloud_connections',
            },
          },
          {
            path: ':id/deepcloud/connect',
            name: 'finances-bank-deepcloud-connect',
            component: DeepCloudConnect,
            meta: {
              title: 'deepcloud_connections',
            },
          },
          {
            path: 'blink/callback/:customerUuid',
            name: 'finance-blink-callback',
            component: OauthCallbackBlink,
          },

          {
            path: ':id/ebanking/:type?',
            name: 'finances-bank-ebanking',
            component: Ebanking,
          },
          {
            path: ':id/authorization',
            name: 'finances-bank-authorization',
            component: OauthAuthorization,
          },
          {
            path: 'ababank',
            name: 'finances-ababank',
            component: Ababank,
            children: [
              {
                path: 'postfinance/:id?',
                name: 'finances-ababank-postfinance',
                component: AbabankPostfinance,
                meta: {
                  title: 'add_postfinance_account',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'creditcards',
        children: [
          {
            path: '',
            name: 'creditcard',
            redirect: '/v3/finances/payment-cards',
            meta: {
              title: 'creditcards',
            },
          },
        ],
      },
    ],
  },
];
